module.exports = __webpack_public_path__ + "img/xpu-ha-pool-2.24a5339a.jpg";